// Loads Spotify's official embed IFrame API once per page, and caches the
// resolved controller factory. Using the real API (instead of a static
// `<iframe src="...">`) lets us call play()/pause()/loadUri() programmatically --
// needed to start playback immediately on a button press, or to play silently
// in a hidden iframe with no visible Spotify widget.
let apiPromise = null;

export function loadSpotifyIframeApi() {
  if (apiPromise) return apiPromise;
  apiPromise = new Promise((resolve) => {
    window.onSpotifyIframeApiReady = (IFrameAPI) => resolve(IFrameAPI);
    const script = document.createElement("script");
    script.src = "https://open.spotify.com/embed/iframe-api/v1";
    script.async = true;
    document.body.appendChild(script);
  });
  return apiPromise;
}
